/* GET Ticket Sessions */
export const GET_SESSION_TICKETS = "GET_SESSION_TICKETS"
export const GET_SESSION_TICKETS_SUCCESS = "GET_SESSION_TICKETS_SUCCESS"
export const GET_SESSION_TICKET_FAIL = "GET_SESSION_TICKET_FAIL"

/* Ticket Sessions DETAIL*/
export const GET_SESSION_TICKET_DETAIL = "GET_SESSION_TICKET_DETAIL"
export const GET_SESSION_TICKET_DETAIL_SUCCESS =
  "GET_SESSION_TICKET_DETAIL_SUCCESS"
export const GET_SESSION_TICKET_DETAIL_FAIL = "GET_SESSION_TICKET_DETAIL_FAIL"

/**
 * ADD Ti cket Sessions
 */
export const ADD_NEW_SESSION_TICKET = "ADD_NEW_SESSION_TICKET"
export const ADD_SESSION_TICKET_SUCCESS = "ADD_SESSION_TICKET_SUCCESS"
export const ADD_SESSION_TICKET_FAIL = "ADD_SESSION_TICKET_FAIL"

/**
 * EDIT Ticket Sessions
 */
export const UPDATE_SESSION_TICKET = "UPDATE_SESSION_TICKET"
export const UPDATE_SESSION_TICKET_SUCCESS = "UPDATE_SESSION_TICKET_SUCCESS"
export const UPDATE_SESSION_TICKET_FAIL = "UPDATE_SESSION_TICKET_FAIL"

/**
 * Delete Ticket Sessions
 */
export const DELETE_SESSION_TICKET = "DELETE_SESSION_TICKET"
export const DELETE_SESSION_TICKET_SUCCESS = "DELETE_SESSION_TICKET_SUCCESS"
export const DELETE_SESSION_TICKET_FAIL = "DELETE_SESSION_TICKET_FAIL"

/**
 * Export Ticket Sessions
 */
export const GET_EXPORT_SESSION_TICKETS = "GET_EXPORT_SESSION_TICKETS"
export const GET_EXPORT_SESSION_TICKETS_SUCCESS =
  "GET_EXPORT_SESSION_TICKETS_SUCCESS"
export const GET_EXPORTED_SESSION_TICKETS_FAIL =
  "GET_EXPORTED_SESSION_TICKETS_FAIL"
export const RESET_EXPORT_DATA = "RESET_EXPORT_DATA"

/**
 * CLEAR MESSAGE AND ERROR OBJECT
 */
export const CLEAR_MESSAGE = "CLEAR_MESSAGE"

/**
 * POST Lift Up Barrier entry/exit request
 */
export const MANUAL_LIFTUP_BARRIER_REQ = "MANUAL_LIFTUP_BARRIER_REQ"
export const MANUAL_LIFTUP_BARRIER_SUCCESS = "MANUAL_LIFTUP_BARRIER_SUCCESS"
export const MANUAL_LIFTUP_BARRIER_FAIL = "MANUAL_LIFTUP_BARRIER_FAIL"
